// extracted by mini-css-extract-plugin
export default {"history":"lsf-history","history__action":"lsf-history__action","history__action_delete":"lsf-history__action_delete","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380201
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  